<template>
  <div>
    <div>
      <h1 class="text-center">Privileges Category</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListPrivilegeCategory.vue";
export default {
  components: {
    List,
  },
};
</script>
